import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const CONSUMED_CHECKOUT_ID_STORAGE_KEY = "consumed-checkout-id";

export const checkoutReturnIdAtom = atom<string | null>(null);

export const consumedCheckoutIdAtom = atomWithStorage<string | null>(
  CONSUMED_CHECKOUT_ID_STORAGE_KEY,
  null,
  createJSONStorage(() => localStorage),
  { getOnInit: true }
);
